export default { options: { label: 'Subscriptions' } }
